import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

export const ACTIVATE_CAMPAIGN_URL = '/campaigns/activateTriggered';

export const useActivateCampaignMutation = () => {
  const { isLoading, mutate, error } = useRestMutation(ACTIVATE_CAMPAIGN_URL, ApiMethod.post);
  return { isLoading, mutate, error };
};
